const dummyBookingComKpiData = {
  supply_vacation_rentals: 100,
  supply_boutique_hotels: 100,
  supply_large_hotels_and_resorts: 100,
  hotel_nightly_rate: 100,
};

const dummyLTRKpiData = {
  rent_range: [1000, 2000],
};

const dummyBookingComVacationRentalComps = [
  {
    listingID: '6255645',
    bathrooms: null,
    bedrooms: '2',
    accommodates: 4,
    name: 'Pristine Elegance meets Chic Charm!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/727009908.jpg?k=6ca47fc3eb80d7b5cc66a29f2800802c07eda8eb2fcfea8b13eeb39c042e54ee&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.486937,
    longitude: -84.3426379,
    minimum_nights: null,
    visible_review_count: 11,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 56505,
    revenue_potential: 56660,
    avg_occupancy_rate_ltm: 79,
    avg_booked_daily_rate_ltm: 196,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/newly-furnished-townhouse-near-everything.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 15,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.35,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.07,
      review_penalizer: -0.2,
      accommodates_score: 0.01,
      activity_penalizer: 0,
      occupancy_rate_score: 0.04,
    },
    similarity_score: 0.27,
    distance: 6573,
    ota: 'booking',
  },
  {
    listingID: '8918100',
    bathrooms: null,
    bedrooms: '1',
    accommodates: 2,
    name: 'Pet-Friendly Tallahassee Retreat, Near Parks!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/382886616.jpg?k=83dcbedc74c38f1a321d165a25354b1a0393eb3ef3f37913b060b8f2ee27c5fb&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.4448324,
    longitude: -84.2581901,
    minimum_nights: null,
    visible_review_count: 1,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 40245,
    revenue_potential: 40356,
    avg_occupancy_rate_ltm: 47,
    avg_booked_daily_rate_ltm: 235,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/pet-friendly-tallahassee-retreat-near-parks.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 3,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.7,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.12,
      review_penalizer: -0.2,
      accommodates_score: 0.03,
      activity_penalizer: 0,
      occupancy_rate_score: 0.02,
    },
    similarity_score: 0.67,
    distance: 3825,
    ota: 'booking',
  },
  {
    listingID: '9475599',
    bathrooms: null,
    bedrooms: '3',
    accommodates: 6,
    name: 'Tallahassee Townhome 4 Mi to College Town!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/646678302.jpg?k=f9d86d05c2775820dabacee2c76a5f3b5a71413116a0e8761eb2a0f12449a525&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.466322,
    longitude: -84.34087,
    minimum_nights: null,
    visible_review_count: 3,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 78577,
    revenue_potential: 78792,
    avg_occupancy_rate_ltm: 100,
    avg_booked_daily_rate_ltm: 215,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/tallahassee-townhome-4-mi-to-college-town.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 28,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.23,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.1,
      review_penalizer: -0.2,
      accommodates_score: 0.01,
      activity_penalizer: 0,
      occupancy_rate_score: 0.05,
    },
    similarity_score: 0.19,
    distance: 4917,
    ota: 'booking',
  },
  {
    listingID: '10029453',
    bathrooms: null,
    bedrooms: '3',
    accommodates: 8,
    name: 'Bright Tallahassee Vacation Rental Near FSU and FAMU',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/456804107.jpg?k=05ac16387fbe543d436c91c363ff144761cff1c4ae0e84940b9aa80d711de04b&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.41313851914785,
    longitude: -84.29004058442115,
    minimum_nights: null,
    visible_review_count: 1,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 85068,
    revenue_potential: 85301,
    avg_occupancy_rate_ltm: 47,
    avg_booked_daily_rate_ltm: 496,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/bright-tallahassee-vacation-rental-near-fsu-and-famu.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 24,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.23,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.13,
      review_penalizer: -0.2,
      accommodates_score: 0.01,
      activity_penalizer: 0,
      occupancy_rate_score: 0.02,
    },
    similarity_score: 0.19,
    distance: 3307,
    ota: 'booking',
  },
  {
    listingID: '10564477',
    bathrooms: null,
    bedrooms: '1',
    accommodates: 4,
    name: '4 Mi to Dtwn Pet-Friendly Abode in Tallahassee!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/482550242.jpg?k=17dd815dfe76a01311825fcc14e44acad68674e6a70b05048f40c41ea3b35e18&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.463865,
    longitude: -84.3281219,
    minimum_nights: null,
    visible_review_count: 3,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 33989,
    revenue_potential: 34082,
    avg_occupancy_rate_ltm: 42,
    avg_booked_daily_rate_ltm: 222,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/tallahassee-townhome-with-patio-near-fsu-campus.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 7,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.7,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.12,
      review_penalizer: -0.2,
      accommodates_score: 0.01,
      activity_penalizer: 0,
      occupancy_rate_score: 0.02,
    },
    similarity_score: 0.65,
    distance: 3771,
    ota: 'booking',
  },
  {
    listingID: '10808683',
    bathrooms: null,
    bedrooms: '3',
    accommodates: 8,
    name: 'Cozy - Organic Modern - Bungalow - FSU',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/494169260.jpg?k=01d4aaafd2ec73523673648b51bc67938a31fa83fcee1919a2e59b55d1ec433b&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.4203247,
    longitude: -84.2665212,
    minimum_nights: null,
    visible_review_count: 3,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 113769,
    revenue_potential: 114081,
    avg_occupancy_rate_ltm: 70,
    avg_booked_daily_rate_ltm: 445,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url: 'https://www.booking.com/hotel/us/cozy-organic-modern-bungalow.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 25,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.23,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.12,
      review_penalizer: -0.2,
      accommodates_score: 0.01,
      activity_penalizer: 0,
      occupancy_rate_score: 0.03,
    },
    similarity_score: 0.19,
    distance: 3865,
    ota: 'booking',
  },
  {
    listingID: '11047415',
    bathrooms: null,
    bedrooms: '1',
    accommodates: 4,
    name: 'Midtown at Marion Green 1BR 1BA, 2 miles FAMU FSU, 2blks TMH',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/505018746.jpg?k=898f4c0d0c61100d18dd1e6d5712a1640c572e325345cfce1262d0d381a79544&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.458792,
    longitude: -84.26610969,
    minimum_nights: null,
    visible_review_count: 4,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 27643,
    revenue_potential: 27719,
    avg_occupancy_rate_ltm: 42,
    avg_booked_daily_rate_ltm: 180,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/midtown-at-marion-green-1br-1ba-2-miles-famu-fsu-2blks-tmh.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 6,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.7,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.13,
      review_penalizer: -0.2,
      accommodates_score: 0.01,
      activity_penalizer: 0,
      occupancy_rate_score: 0.02,
    },
    similarity_score: 0.66,
    distance: 3574,
    ota: 'booking',
  },
  {
    listingID: '11054189',
    bathrooms: null,
    bedrooms: '1',
    accommodates: 3,
    name: '1BR 1BA in Tallahassee Midtown close to FAMU, FSU and TMH',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/505327929.jpg?k=9324059c0783c22fc09e9bfd6f31a2cb97dcced6602a1583197fc8b99fe1a58b&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.4587921,
    longitude: -84.2661098,
    minimum_nights: null,
    visible_review_count: 2,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 29477,
    revenue_potential: 29558,
    avg_occupancy_rate_ltm: 42,
    avg_booked_daily_rate_ltm: 192,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/midtown-at-marion-blue-2-miles-famu-fsu.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 2,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.7,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.13,
      review_penalizer: -0.2,
      accommodates_score: 0.02,
      activity_penalizer: 0,
      occupancy_rate_score: 0.02,
    },
    similarity_score: 0.67,
    distance: 3574,
    ota: 'booking',
  },
  {
    listingID: '11191614',
    bathrooms: null,
    bedrooms: '5',
    accommodates: 19,
    name: 'Fantastic Gem Minutes from Campus/Stadium, Capitol',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/513550436.jpg?k=86fee694cf651927a792747ccbfd4389cb2f9de18da8662cdb965c655ea969ca&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.4545436,
    longitude: -84.3125785,
    minimum_nights: null,
    visible_review_count: 2,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 92237,
    revenue_potential: 92490,
    avg_occupancy_rate_ltm: 28,
    avg_booked_daily_rate_ltm: 903,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/fantastic-gem-minutes-from-campus-stadium-capitol.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 34,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.14,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.16,
      review_penalizer: -0.2,
      accommodates_score: 0,
      activity_penalizer: 0,
      occupancy_rate_score: 0.01,
    },
    similarity_score: 0.11,
    distance: 1970,
    ota: 'booking',
  },
  {
    listingID: '11191742',
    bathrooms: null,
    bedrooms: '3',
    accommodates: 19,
    name: 'Mid-Century Comfy-Chic Chateau 3/2 Pet Friendly',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/511633375.jpg?k=e9dc6c725d22cecd852dd5bc1365086f50fc89b3911b1c8b9eda458c7749474f&o=',
    host_id: null,
    host_name: null,
    room_type: 'Vacation Home',
    latitude: 30.4545436,
    longitude: -84.3125785,
    minimum_nights: null,
    visible_review_count: 2,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: 70075,
    revenue_potential: 70267,
    avg_occupancy_rate_ltm: 37,
    avg_booked_daily_rate_ltm: 519,
    active_days_count_ltm: 365,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: {},
    revenue_ltm_monthly: {},
    occupancy_rate_ltm_monthly: {},
    listing_url:
      'https://www.booking.com/hotel/us/mid-century-comfy-chic-chateau-3-2-pet-friendly.en-gb.html',
    no_of_bookings_ltm_monthly: {},
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 21,
    similarity_score_meta: {
      pool_score: 0,
      bedroom_score: 0.23,
      revenue_score: 0,
      bathroom_score: 0,
      proximity_score: 0.16,
      review_penalizer: -0.2,
      accommodates_score: 0,
      activity_penalizer: 0,
      occupancy_rate_score: 0.02,
    },
    similarity_score: 0.21,
    distance: 1970,
    ota: 'booking',
  },
];

const dummyBookingComHotelComps = [
  {
    listingID: '6255645',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Pristine Elegance meets Chic Charm!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/727009908.jpg?k=6ca47fc3eb80d7b5cc66a29f2800802c07eda8eb2fcfea8b13eeb39c042e54ee&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.486937,
    longitude: -84.3426379,
    minimum_nights: null,
    visible_review_count: 11,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 196,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 15,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '8918100',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Pet-Friendly Tallahassee Retreat, Near Parks!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/382886616.jpg?k=83dcbedc74c38f1a321d165a25354b1a0393eb3ef3f37913b060b8f2ee27c5fb&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.4448324,
    longitude: -84.2581901,
    minimum_nights: null,
    visible_review_count: 1,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 235,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 3,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '9475599',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Tallahassee Townhome 4 Mi to College Town!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/646678302.jpg?k=f9d86d05c2775820dabacee2c76a5f3b5a71413116a0e8761eb2a0f12449a525&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.466322,
    longitude: -84.34087,
    minimum_nights: null,
    visible_review_count: 3,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 215,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 28,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '10029453',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Bright Tallahassee Vacation Rental Near FSU and FAMU',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/456804107.jpg?k=05ac16387fbe543d436c91c363ff144761cff1c4ae0e84940b9aa80d711de04b&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.41313851914785,
    longitude: -84.29004058442115,
    minimum_nights: null,
    visible_review_count: 1,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 496,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 24,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '10564477',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: '4 Mi to Dtwn Pet-Friendly Abode in Tallahassee!',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/482550242.jpg?k=17dd815dfe76a01311825fcc14e44acad68674e6a70b05048f40c41ea3b35e18&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.463865,
    longitude: -84.3281219,
    minimum_nights: null,
    visible_review_count: 3,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 222,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 7,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '10808683',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Cozy - Organic Modern - Bungalow - FSU',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/494169260.jpg?k=01d4aaafd2ec73523673648b51bc67938a31fa83fcee1919a2e59b55d1ec433b&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.4203247,
    longitude: -84.2665212,
    minimum_nights: null,
    visible_review_count: 3,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 445,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 25,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '11047415',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Midtown at Marion Green 1BR 1BA, 2 miles FAMU FSU, 2blks TMH',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/505018746.jpg?k=898f4c0d0c61100d18dd1e6d5712a1640c572e325345cfce1262d0d381a79544&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.458792,
    longitude: -84.26610969,
    minimum_nights: null,
    visible_review_count: 4,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 180,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 6,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '11054189',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: '1BR 1BA in Tallahassee Midtown close to FAMU, FSU and TMH',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/505327929.jpg?k=9324059c0783c22fc09e9bfd6f31a2cb97dcced6602a1583197fc8b99fe1a58b&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.4587921,
    longitude: -84.2661098,
    minimum_nights: null,
    visible_review_count: 2,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 192,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 1,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 2,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '11191614',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Fantastic Gem Minutes from Campus/Stadium, Capitol',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/513550436.jpg?k=86fee694cf651927a792747ccbfd4389cb2f9de18da8662cdb965c655ea969ca&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.4545436,
    longitude: -84.3125785,
    minimum_nights: null,
    visible_review_count: 2,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 903,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 34,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
  {
    listingID: '11191742',
    bathrooms: null,
    bedrooms: null,
    accommodates: null,
    name: 'Mid-Century Comfy-Chic Chateau 3/2 Pet Friendly',
    thumbnail_url:
      'https://cf.bstatic.com/xdata/images/hotel/max1024x768/511633375.jpg?k=e9dc6c725d22cecd852dd5bc1365086f50fc89b3911b1c8b9eda458c7749474f&o=',
    host_id: null,
    host_name: null,
    room_type: 'hotel_room',
    latitude: 30.4545436,
    longitude: -84.3125785,
    minimum_nights: null,
    visible_review_count: 2,
    reveiw_scores_rating: null,
    amenities: {
      parking: false,
      hot_tub: false,
      gym: false,
      pets: false,
      dryer: false,
      washer: false,
      pool: false,
      kitchen: false,
      ac: false,
      wifi: false,
      heating: false,
      tv: false,
      bbq_grill: false,
      fireplace: false,
      breakfast: false,
      beachfront: false,
      amazing_views: false,
    },
    cleaning_fee: null,
    annual_revenue_ltm: null,
    revenue_potential: null,
    avg_occupancy_rate_ltm: null,
    avg_booked_daily_rate_ltm: 519,
    active_days_count_ltm: null,
    no_of_bookings_ltm: null,
    booked_daily_rate_ltm_monthly: null,
    revenue_ltm_monthly: null,
    occupancy_rate_ltm_monthly: null,
    listing_url: null,
    no_of_bookings_ltm_monthly: null,
    is_selected: 0,
    last_seen: null,
    thumbnail_url_extended: null,
    rank: 21,
    similarity_score_meta: {},
    similarity_score: null,
    distance: null,
    ota: null,
  },
];

const dummyLTRComps = [];

const dummyBookingComPrimaryInput = {
  latitude: 30.442087,
  longitude: -84.2979579,
  radius: 2500,
};

export const dummyBookingComData = {
  primary_input: dummyBookingComPrimaryInput,
  kpi: dummyBookingComKpiData,
  vacation_rental_comps: dummyBookingComVacationRentalComps,
  hotel_comps: dummyBookingComHotelComps,
};

export const dummyLTRData = {
  kpi: dummyLTRKpiData,
  comps: dummyLTRComps,
};
